// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__CK_X1","selected":"Chip_selected__thg0c"};